export const ANNOUNCEMENT_STORAGE_KEY = 'maple-log:last-seen-announcement'
const ANNOUNCEMENT_LOCK = 'maple-log:update-announcement'

export class AnnouncementHistory {
  private readonly displayed = new Set<string>()

  constructor(private readonly storage: () => Pick<Storage, 'getItem' | 'setItem'> = () => window.localStorage) {}

  hasSeen(id: string): boolean {
    if (this.displayed.has(id)) return true
    try {
      return this.storage().getItem(ANNOUNCEMENT_STORAGE_KEY) === id
    } catch {
      return false
    }
  }

  markDisplayed(id: string): void {
    this.displayed.add(id)
    try {
      this.storage().setItem(ANNOUNCEMENT_STORAGE_KEY, id)
    } catch {
      // Storage can be disabled; the in-memory history still prevents repeat prompts.
    }
  }
}

export const announcementHistory = new AnnouncementHistory()

export async function withAnnouncementLock(action: () => Promise<void>, signal: AbortSignal, lockName = ANNOUNCEMENT_LOCK): Promise<void> {
  if (signal.aborted) return
  if (!navigator.locks) {
    await action()
    return
  }
  let started = false
  try {
    await navigator.locks.request(lockName, { signal }, async () => {
      started = true
      if (!signal.aborted) await action()
    })
  } catch (error) {
    if (signal.aborted) return
    if (started) throw error
    // Some browser policies expose Web Locks but reject access to it.
    await action()
  }
}
